import admin from './view';

export default [
  {
    path: '/',
    redirect: 'status',
  },
  {
    path: 'status', // KS인증현황
    component: admin('/cert/status'),
  },
  {
    path: 'status/:certNo', // KS인증현황 > 상세조회
    component: admin('/cert/statusDetail'),
  },
  {
    path: 'regular3y', // 정기심사대상관리3년
    component: admin('/cert/regular3y'),
  },
  {
    path: 'regular3y/:sq', // 정기심사대상관리3년 > 상세조회
    component: admin('/cert/regular3yDetail'),
  },
  {
    path: 'regular1y', // 1년 주기 공장심사대상관리
    component: admin('/cert/regular1y'),
  },
  {
    path: 'regular1y/:sq', // 1년 주기 공장심사대상관리 > 상세조회
    component: admin('/cert/regular1yDetail'),
  },
  {
    path: 'material', // 주요자재변경관리
    component: admin('/cert/material'),
  },
  {
    path: 'material/:certNo', // 주요자재변경관리 > 상세조회
    component: admin('/cert/materialDetail'),
  },
  {
    path: 'succession', // 지위승계신청관리
    component: admin('/cert/succession'),
  },
  {
    path: 'succession/:certNo', // 지위승계신청관리 > 상세조회
    component: admin('/cert/successionDetail'),
  },
  {
    path: 'cancelReturn', // 인증취소 / 반납관리
    component: admin('/cert/cancelReturn'),
  },
  {
    path: 'cancelReturn/:certNo', // 인증취소 / 반납관리 > 상세조회
    component: admin('/cert/cancelReturnDetail'),
  },
  {
    path: 'disposition', // 행정처분관리
    component: admin('/cert/disposition'),
  },
  {
    path: 'disposition/:certNo', // 행정처분관리 상세조회
    component: admin('/cert/dispositionDetail'),
  },
  {
    path: 'stopResume', // 생산중단/재개관리
    component: admin('/cert/stopResume'),
  },
  {
    path: 'stopResume/:sq', // 생산중단/재개관리 상세조회
    component: admin('/cert/stopResumeDetail'),
  },
  {
    path: 'unsuitable', // 핵심품질부적합표시정지관리
    component: admin('/cert/unsuitable'),
  },
  {
    path: 'unsuitable/:sq', // 핵심품질부적합표시정지관리 상세조회
    component: admin('/cert/unsuitableDetail'),
  },
  {
    path: 'standardRevision', // KS표준 및 인증심사기준개정
    component: admin('/cert/standardRevision'),
  },
  {
    path: 'standardRevision/:certNo', // KS표준 및 인증심사기준개정 상세조회
    component: admin('/cert/standardRevisionDetail'),
  },
  {
    path: 'specialResearch', // 특별현장조사
    component: admin('/cert/specialResearch'),
  },
  {
    path: 'specialResearch/:certNo', // 특별현장조사 상세조회
    component: admin('/cert/specialResearchDetail'),
  },
  {
    path: 'research', // 현장조사
    component: admin('/cert/research'),
  },
  {
    path: 'research/register', // 현장조사 등록
    component: admin('/cert/researchRegister'),
  },
  {
    path: 'research/:sq', // 현장조사 상세조회
    component: admin('/cert/researchDetail'),
  },

  { path: '*', redirect: '/404' },
];



// WEBPACK FOOTER //
// ./src/router/admin/cert.js